//
// Takes in an ID field, generate a color based on it
// id is either an int or a string. For a string, compute a simple checksum.
//
// Colors rotate around the rainbow, and offset slightly for each turn,
//  avoiding generating the same color
//
// 255 = 5 * 3 * 17
//

const numToHex = (num) => ((Math.floor(num) > 15)
  ? (Math.floor(num)).toString(16)
  : `0${(Math.floor(num)).toString(16)}`);

// const easeOutCalc = (level) => (level + (0.1 * (level ** 2)));

// const easeOut = (level) => {
//   const corrected = easeOutCalc(level);
//   const ret = Math.floor(
//     255
//     * (easeOutCalc(255) - easeOutCalc(255 - level))
//     / easeOutCalc(255),
//   );
//   console.log(`level=${level}, corrected=${corrected}, 255=${easeOutCalc(255)}, ret=${ret}`);
//   return (ret);
// };

const lighten = (level, light) => (level + (light * (255 - level)));

const dim = (level, dimming) => (level * (1 - dimming));

const idToColor = (inputId, dimming = 0, light = 0, step = 54, shifted = true) => {
  let id = 0;
  if (typeof inputId === 'string') {
    for (let i = 0; i < inputId.length; i += 1) {
      id += inputId.charCodeAt(i);
    }
  } else {
    id = inputId;
  }

  // hue from 0 to 255, 0:Red, 85: green, 170: blue
  // most visible changes around 44, 128, 213
  //
  // nice step values, dealing with wrap around: 19, 22, 27

  const hue = (step * id) % 255;

  let yellow = 54;
  let green = 85;
  let blueGreen = 116;
  let blue = 164;
  let pink = 224;
  if (!shifted) {
    // Should be:
    yellow = 43;
    green = 85;
    blueGreen = 128;
    blue = 170;
    pink = 213;
    //
    // But colors shifted so as to see more differences
  }

  let r;
  let g;
  let b;
  if (hue < (yellow + 1)) {
    r = dim(255, dimming);
    // 0: 0, 43: 255
    g = lighten(dim(hue * 255 / yellow, dimming), light);
    b = lighten(0, light);
  } else if (hue < green) {
    // 43: 255, 85:0
    r = lighten(dim((green - hue) * 255 / (green - yellow), dimming), light);
    g = dim(255, dimming);
    b = lighten(0, light);
  } else if (hue < blueGreen) {
    r = lighten(0, light);
    g = dim(255, dimming);
    // 85: 0, 128:255
    b = lighten(dim((hue - green) * 255 / (blueGreen - green), dimming), light);
  } else if (hue < blue) {
    r = lighten(0, light);
    // 128: 255, 170:0
    g = lighten(dim((blue - hue) * 255 / (blue - blueGreen), dimming), light);
    b = dim(255, dimming);
  } else if (hue < pink) {
    // 170: 0, 213:255
    r = lighten(dim((hue - blue) * 255 / (pink - blue), dimming), light);
    g = lighten(0, light);
    b = dim(255, dimming);
  } else {
    r = dim(255, dimming);
    g = lighten(0, light);
    // 213: 255, 256:0
    b = lighten(dim((256 - hue) * 255 / (256 - pink), dimming), light);
  }

  // r = easeOut(r);
  // g = easeOut(g);
  // b = easeOut(b);

  const ret = `#${numToHex(r)}${numToHex(g)}${numToHex(b)}`;

  // console.log(`inputId=${inputId} dimming=${dimming} light=${light} r=${
  //   Math.floor(r)} g=${Math.floor(g)} b=${Math.floor(b)} ret=${ret}`);

  return ret;
};

export default idToColor;
